<template>
  <div class="all-msgks elevation-1">
    <v-toolbar class="user-history-toolbar" flat color="white">
      <v-text-field flat solo full-width clearable v-model="search" prepend-icon="search" label="Suche"></v-text-field>
      <v-select :items="teamOptions" v-model="selectedTeam" v-on:change="filterByTeams" ></v-select>
    </v-toolbar>
    <jw-pagination :items="allMsgks" :pageSize=10 :maxPages=4 @changePage="onChangePage" class="d-flex"></jw-pagination>
    <vue-perfect-scrollbar class="chat-history--scrollbar">
      <v-list two-line class="user-history--list">
        
        <template v-if="isAdmin || isManager">
         <v-list-tile class="user-list">
            <v-list-tile-avatar color="white" @click="newMsgk">
              <v-icon color="secondary" large>
                add_circle
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="black--text">New Msgk</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar color="white" @click="orderAsc">
              <v-icon color="secondary" large>
                swap_vert
              </v-icon>
            </v-list-tile-avatar>
           </v-list-tile>
           
        </template>
        <template v-for="(item, index) in filteredList">
          <v-list-tile class="user-list" :key="item.materialGrp + index" :to="msgkRoute(item.materialGrp)" :class="{active:$route.params.materialGrp  == item.materialGrp}">
            <v-list-tile-avatar color="primary">
              
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="black--text">{{item.materialGrp}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text>
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>   
  </div>
</template>

<script>
import API from '@/api'
import JwPagination from 'jw-vue-pagination'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components: {
      VuePerfectScrollbar,
      JwPagination
    },    
    data: () => ({
      allMsgks: [],
      filteredMsgks: [],
      search: '',
      teamOptions : [],
      isAscending : false,
      selectedTeam: "All",
      pageOfItems: [],
      rules: {
          required: value => !!value || 'Required.'
      }
    }),
    mounted(){
        this.getAllMsgks()
        this.$root.$on('refreshMsgks', () => {
          this.getAllMsgks();
        })
         API.getTeams().then(teamOptions  => {
            this.teamOptions = teamOptions;      
            this.teamOptions.push("All");
          });
    },
    methods:{
        async getAllMsgks(){
          this.allMsgks = await API.getMsgks();
        },
        msgkRoute (materialGrp) {
          return `/msgk/manageMsgks/${materialGrp}`;
        },
        newMsgk() {
          this.$router.push('/msgk/manageMsgks/new');
        },
        orderAsc() {
          this.allMsgks = this.allMsgks.sort((a, b) => a.materialGrp.localeCompare(b));
        },
        onChangePage(pageOfItems) {
          // update page of items
          this.pageOfItems = pageOfItems;
        },
        async filterByTeams() {
          this.allMsgks = await API.getMsgksByTeam(this.selectedTeam);
        }
    },
    computed: {
        filteredList() {
          
          if (this.search) {
            let searchString = this.search.toLowerCase();
            let filteredData = this.allMsgks.filter(item => {
              const containsCart = item.materialGrp ? item.materialGrp.toLowerCase().includes(searchString) : false
              return containsCart;
            });
            return filteredData;
          } else {
            return this.pageOfItems
          }
        },
        isAdmin() {
          if (localStorage.getItem("role") &&  localStorage.getItem("role").toLowerCase() === 'admin') {
              return true;
          } else {
              return false;
          }
        },
        isManager() {
            if (localStorage.getItem("role") &&  localStorage.getItem("role").toLowerCase() === 'management') {
              return true;
            } else {
              return false;
            }
        }
    }
}
</script>
<style>
  .active {
    font-size:16px;
    font-weight: bold;
  }
  .all-msgks{
    margin-top: 16px;
  }
  .user-list.active {
    background: rgb(220, 220, 220);
  }
</style>